<template>
  <div id="printNegativeRastreability" class="print">
    <div class="section">
      <div class="columns is-variable is-multiline">
        <div class="column is-3 ">
          <figure class="image is-128x128 center-content">
            <img
              class=""
              src="../../assets/imgs/logo-petit-nature.jpg"
              alt=""
            />
          </figure>
        </div>
        <div class="column is-6 center-content title">
          <div>
            <h1 class="title has-text-centered">
              Procedimento Operacional Padrão
            </h1>
          </div>
          <div>
            <h2 class="subtitle has-text-centered">Rastreabilidade Negativa</h2>
          </div>
        </div>
        <div class="column is-3 center-content">
          <div class="label">
            {{ new Date() | moment("DD/MM/YYYY") }}
          </div>
        </div>
      </div>
      <div
        v-if="receipt.id"
        class="columns is-variable is-multiline has-text-left"
      >
        <div class="column is-12">
          <div class="label">Produto Final: {{ receipt.receipt.name }}</div>
          <div class="label">Lote: {{ receipt.batch }}</div>
          <div class="label">
            Data de fabricação:
            {{ receipt.manufacturingDate | moment("DD/MM/YYYY") }}
          </div>
          <div class="label">
            Data de validade:
            {{ receipt.expirationDate | moment("DD/MM/YYYY") }}
          </div>
        </div>
        <!--Table -->
        <div class="column is-12">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Insumo</th>
                <th>Lote</th>
                <th>Data de compra</th>
                <th>Validade</th>
                <th>Preço</th>
                <th>Kg</th>
                <th>Nª NF/Recibo</th>
                <th>Fornecedor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="supply in receipt.supplies" :key="supply.id">
                <td>{{ supply.ingredient.name }}</td>
                <td>{{ supply.batch }}</td>
                <td>{{ supply.purchaseDate | moment("DD/MM/YYYY") }}</td>
                <td>{{ supply.expirationDate | moment("DD/MM/YYYY") }}</td>
                <td>{{ supply.price || 0 | currency }}</td>
                <td>{{ supply.size || 0 }}</td>
                <td>{{ supply.nfNumber }}</td>
                <td>{{ supply.manufacturer.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="column is-12 sign-holder has-text-centered">
          <div class="sign-line">
            ____________________________________________
          </div>
          <h2 class="subtitle">
            Funcionário responsável
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../../helpers/EventBus";
import Vue from "vue";

export default {
  name: "PrintNegativeRastreability",
  data: () => ({
    receipt: {}
  }),
  methods: {},
  created() {
    EventBus.$on("print:negativeRastreability", receipt => {
      let that = this;
      this.receipt = receipt;
      //Used here to ensure that functions will be called only when object has values
      Vue.nextTick(function() {
        that.$htmlToPaper("printNegativeRastreability");
      });
    });
  },
  beforeDestroy() {
    EventBus.$off("print:negativeRastreability");
  }
};
</script>

<style lang="scss" scoped>
@media print {
  html,
  body {
    border: 1px solid white;
    height: 99%;
    page-break-after: avoid;
    page-break-before: avoid;
  }
  .image.center-content,
  .column.center-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .column.center-content.title {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .sign-holder.section {
    position: fixed;
    bottom: 0;
  }
}
</style>
